<div class="subcategory-description-main" *ngIf="catSelected?.descriptions">
  <h2 class="section-title" *ngIf="catSelected?.format === 'plain'">
    {{ catSelected?.descriptions?.title }}
  </h2>
  <h2
    class="section-title"
    *ngIf="catSelected?.format === 'html'"
    [innerHTML]="catSelected?.descriptions?.title"
  ></h2>

  <p *ngIf="catSelected?.format === 'plain'">
    {{ catSelected?.descriptions?.text }}
  </p>
  <div
    *ngIf="catSelected?.format === 'html'"
    [innerHTML]="catSelected?.descriptions?.text"
  ></div>

  <div
    class="subcategory-description-itens"
    *ngFor="let sub of catSelected?.descriptions?.sections"
  >
    <h3 *ngIf="catSelected?.format === 'plain'">{{ sub.subtitle }}</h3>
    <h3 *ngIf="catSelected?.format === 'html'" [innerHTML]="sub.subtitle"></h3>

    <p *ngIf="catSelected?.format === 'plain'">{{ sub.text }}</p>
    <div *ngIf="catSelected?.format === 'html'" [innerHTML]="sub.text"></div>
  </div>

  <div *ngIf="(catSelected?.faqs?.length || 0) > 0" class="subcategory-faq">
    <h2 class="section-title">FAQ - Perguntas Frequentes</h2>

    <div class="subcategory-faq-itens" *ngFor="let faq of catSelected?.faqs">
      <h3 *ngIf="catSelected?.format === 'plain'">{{ faq.question }}</h3>
      <h3
        *ngIf="catSelected?.format === 'html'"
        [innerHTML]="faq.question"
      ></h3>

      <p *ngIf="catSelected?.format === 'plain'">{{ faq.answer }}</p>
      <div
        *ngIf="catSelected?.format === 'html'"
        [innerHTML]="faq.answer"
      ></div>
    </div>
  </div>
</div>
